import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { ImageSliderAnalyticsEvent } from '@liveauctioneers/hammer-ui-core/imageSlider';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '../core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackItemImageGalleryInteractionPayload = ImageSliderAnalyticsEvent & TrackingPayload;

export const trackItemImageGalleryInteractionAnalytics = (payload: TrackItemImageGalleryInteractionPayload) => {
    track(TrackingEvents.Item.ItemImageGalleryInteractionClicked, payload);
};

export const useTrackItemImageGalleryInteractionAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ imagePosition, interactionType, totalImages }: ImageSliderAnalyticsEvent) => {
            return trackItemImageGalleryInteractionAnalytics({
                imagePosition,
                interactionType,
                pageName: getAmplitudePageNameFromPath(pathname),
                totalImages,
                url,
            });
        },
        [pathname, url]
    );
};
